import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import PersonalBelongingsForm from "./PersonalBelongingsForm";
import { useDispatch } from "react-redux";
import { createPersonalBelonging } from "../../../store/slices/personalBelongingsSlice";
import { fetchPatient } from "../../../store/slices/patientsSlice";

const AddPersonalBelonging = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};

    useEffect(() => {
        if (patientId) {
            dispatch(fetchPatient(patientId))
                .unwrap()
                .then((patient) => {
                    if (patient) {
                        setFormData((prev) => ({
                            ...prev,
                            clientName: `${patient.first_name || ""} ${patient.last_name || ""}`.trim(),
                        }));
                    }
                })
                .catch((err) => console.error("Failed to fetch patient details:", err));
        }
    }, [dispatch, patientId]);

    const [formData, setFormData] = useState({
        patientId, // initialize
        caseId,    // initialize
        clientName: "",
        // caregiverName: "",
        relation: "",
        belongings: [{ name: "" }],
        relativeName: "",
        trhStaffName: "",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.clientName) newErrors.clientName = "Client name is required";
        // if (!formData.caregiverName)
        //     newErrors.caregiverName = "Caregiver name is required";
        if (
            !formData.belongings ||
            formData.belongings.length === 0 ||
            formData.belongings.some((b) => !b.name.trim())
        ) {
            newErrors.belongings = "Please list at least one belonging";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            Swal.fire({
                title: "Missing Fields",
                text: "Please fill all required fields before submitting.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        // ✅ include case_id and patient_id in payload
        const payload = {
            ...formData,
            patient_id: formData.patientId || patientId,
            case_id: formData.caseId || caseId,
        };

        try {
            // ✅ Send payload with IDs included
            const res = await dispatch(createPersonalBelonging(payload)).unwrap();

            Swal.fire({
                title: "Success!",
                text: "Personal belonging record added successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            // ✅ Navigate back to case profile
            navigate(`/phase04/personal-belongings/edit/${res.id || res.data?.id || (res && res[0]?.id)}`, { state: { patientId: patientId || (res && res.patient_id), caseId: caseId || (res && res.case_id) } });
        } catch (err) {
            console.error("Failed to create belonging:", err);
            Swal.fire({
                title: "Error!",
                text: "Failed to save personal belonging. Please try again.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        {Object.keys(errors).length > 0 && (
                            <div className="alert alert-danger">
                                {Object.values(errors).map((err, i) => (
                                    <div key={i}>{err}</div>
                                ))}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <PersonalBelongingsForm
                                formData={formData}
                                setFormData={setFormData}
                                handleChange={handleChange}
                            />

                            {/* ✅ Submit Button here */}
                            <div className="col-12 d-flex justify-content-end mt-2">
                                <div className="mt-3 col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary px-4 sticky-form-submit">
                                        <i className="ri-save-3-line me-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddPersonalBelonging;
